import React, { useEffect, useState } from "react";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import HeadingText from "../../common/HeadingText/HeadingText";
import { Container, Form, Row, Col, Input } from "reactstrap";
import "./TourAssignment.scss";
import ButtonComponent from "../../common/Button/ButtonComponent";
import LoaderComponent from "../../common/Loader/Loader";
import Toaster from "../../common/Toaster/Toaster";
import AsyncSelectComponent from "../../common/AsyncSelect/AsyncSelect";
import {
  IAssignTourPayload,
  ITourAssignmentPageProps,
  ITourPageState,
  ITourReassignmentModalProps,
} from "../../../interfaces/Index";
import { checkTourOrRiderAssignment } from "../../../redux/sources/ShipperSource";
import debounce from "debounce-promise";
import { normalizeTourAndRiderCheckResponse } from "../../../normalizer/ShipperNormalizer";
import { Can } from "../../../config/Can";
import {
  acceptableFormats,
  TOUR_REASSIGNMENT_CODES,
} from "../../../config/constants";
import { UPLOAD_TOUR_CSV_URL } from "../../../config/Url";
import { normalizeBulkUploadPayload } from "../../../normalizer/GlobalProductNormalizer";
import ReassignmentTourModal from "./ReassignmentTourModal/ReassignmentTourModal";

export const doAPIsearch = async (val: any, isTour: boolean) => {
  if (val.length >= 3) {
    return normalizeTourAndRiderCheckResponse(
      await checkTourOrRiderAssignment(
        isTour ? { tourNumber: val } : { phoneNumber: val },
        isTour
      )
    );
  } else {
    return new Promise((resolve) => {
      resolve([]);
    });
  }
};

const TourAssignmentPage: React.FunctionComponent<ITourAssignmentPageProps> = (
  props
) => {
  const headingText = "Tour assignment";

  const buttonText = "Assign";

  const [tourState, setTourState] = useState<ITourPageState>({
    tourSearchSelect: props.dummyTour || "",
    riderSearchSelect: props.dummyRider || "",
  });

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [showModal, setModalStatus] = useState(false);

  // This flow needs refactoring for scalability
  useEffect(() => {
    const { isTourAssigned } = props;
    if (isTourAssigned) {
      const message = "Tour assigned successfully!";
      handleToaster(false, message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      const { error, isError } = props;
      if (isError) {
        const errorCode = (error as any).errorCode;
        handleToaster(true, (error! as any).errors);
      }
    }
  }, [props.isTourAssigned]);

  // This flow needs refactoring for scalability
  useEffect(() => {
    const { isCsvUploaded } = props;
    if (isCsvUploaded) {
      const message = "Tour CSV uploaded successfully!";
      handleToaster(false, message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [props.isCsvUploaded]);

  // This flow needs refactoring for scalability
  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      const errorCode = (error as any).errorCode;
      if (errorCode && TOUR_REASSIGNMENT_CODES.includes(errorCode)) {
        setModalStatus(true);
      } else {
        alert((error! as any).errors);
      }
    }
  }, [props.isError]);

  const validateForm = !!(
    tourState.riderSearchSelect && tourState.tourSearchSelect
  );

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleAsyncSelectChange = (e: any, action: any) => {
    if (e.__isNew__) {
      setTourState({
        ...tourState,
        [action.name]: e.value,
      });
    }
  };

  const handleSearchInputChange = debounce(
    (val: any, isTour: any) => doAPIsearch(val, isTour),
    1000
  );

  const handleSubmit = () => {
    const { assignTour } = props;
    const payload: IAssignTourPayload = {
      ridersPhone: tourState.riderSearchSelect,
      tourNumber: tourState.tourSearchSelect,
    };
    assignTour(payload);
  };

  const handleCSVInputChange = (e: any) => {
    const { uploadTourCsv } = props;
    const file = e.target.files[0];
    if (file) {
      uploadTourCsv(normalizeBulkUploadPayload(file), UPLOAD_TOUR_CSV_URL);
      e.target.value = null;
    }
  };

  const renderTourDetail = () => {
    return (
      <FormSectionLayout subTitleText="Assignment">
        <section className="form-group search-container">
          <label className="block text-uppercase label">
            Search for Tour Number
          </label>
          <AsyncSelectComponent
            id="tourSearchSelect"
            name="tourSearchSelect"
            placeHolderText="Search by tour number"
            handleAsyncSelectChange={handleAsyncSelectChange}
            loadAsyncOptions={(val) => handleSearchInputChange(val, true)}
            isCustomSelectValue={false}
            isDisabled={props.isEdit}
            isCreatable
          />
        </section>
        <section className="form-group search-container">
          <label className="block text-uppercase label">Select Rider</label>
          <AsyncSelectComponent
            id="riderSearchSelect"
            name="riderSearchSelect"
            placeHolderText="Search rider phone number"
            handleAsyncSelectChange={handleAsyncSelectChange}
            loadAsyncOptions={(val) => handleSearchInputChange(val, false)}
            isCustomSelectValue={false}
            isDisabled={props.isEdit}
            isCreatable
          />
        </section>
        {renderFormButton()}
      </FormSectionLayout>
    );
  };

  const renderConfirmationModal = () => {
    const errorFullResponse = (props.error as any).errorFullResponse;
    const riderId: string = errorFullResponse
      ? errorFullResponse.riderId
      : null;
    const modalProps: ITourReassignmentModalProps = {
      riderId,
      open: true,
      texts: (props.error! as any).errors,
      tourNumber: tourState.tourSearchSelect,
      reassignTour: props.reassignTour,
      closeHandler: setModalStatus,
    };
    return (
      <ReassignmentTourModal
        key={tourState.riderSearchSelect}
        {...modalProps}
      />
    );
  };

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row
          id="addEditButtonRow"
          className="add-update-button-container tour-button"
        >
          <Can I="update" a="tour">
            <Col lg="6">
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={props.isLoading || !validateForm}
              />
            </Col>
            <Col lg="6">
              <label htmlFor="upload" className="csv-upload-container">
                <span>Or upload .csv ...</span>
                <Input
                  id="upload"
                  type="file"
                  name="upload"
                  accept={acceptableFormats.csv}
                  onChange={handleCSVInputChange}
                  className="csv-upload-link"
                />
              </label>
            </Col>
          </Can>
        </Row>
      </div>
    );
  };

  return (
    <Container fluid>
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row className="tour-assignment-heading">
        <Col lg="5">
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="tour-details">{renderTourDetail()}</div>
          </Form>
        </Col>
      </Row>
      {showModal ? renderConfirmationModal() : null}
    </Container>
  );
};

export default TourAssignmentPage;
